export enum WebProductId {
  // Matura
  MaturaM1 = 'matura_for_1_month',
  MaturaM3 = 'matura_for_3_months',
  MaturaM6 = 'matura_for_6_months',
  MaturaM12 = 'matura_for_12_months',

  // Exam
  ExamM1 = 'exam_for_1_month',
  ExamM3 = 'exam_for_3_months',
  ExamM6 = 'exam_for_6_months',
  ExamM12 = 'exam_for_12_months',

  // Ending 2021-08-31
  MaturaRetake = 'matura-retake-ending-2021-08-31',

  // Archived
  Matura = 'matura-subscription-ending-2021-08-31',
  Exam = 'exam-subscription-ending-2021-08-31',
}
